<div class="container">
  <header-i18n showLangText="false" class="langs" />
  <div class="wrap">
    <div class="top">
      <div class="head">
        <img class="logo" src="./assets/img/logo.png">
        <span class="title">Sead Agro-Advisory</span>
      </div>
      <div class="desc"></div>
    </div>
    <router-outlet />
    <global-footer>
      BIM
      <i class="anticon anticon-copyright"></i> 2025 Copyright
      <li>
        <a href="" (click)="$event.preventDefault()">Version&#64; {{currentVersion}}</a>
      </li>
      </global-footer>
  </div>
</div>